import React from 'react';
import {UserMenu} from './menu';
import _UserLayout from './_UserLayout.scss';

class UserLayout extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      active: ''
    }
  }

  componentDidMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  render() {
    return (
      <div className="center">
        <div className="row">
          <UserMenu active={this.props.active}/>
          <section className="user-container">
            {
              this.props.children
            }
          </section>
        </div>
      </div>
    );
  }
}

export default UserLayout;



// WEBPACK FOOTER //
// ./components/layouts/user/UserLayout.jsx